import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import AppModalContent from "../../../Modals/AppModalContent";
import {
  DamageCostEvaluationApplyDamageCorrections,
  DamageCostEvaluationApplyDamageCorrectionsProps,
} from "./DamageCostEvaluationApplyDamageCorrections";

export interface OwnProps {
  subProps: DamageCostEvaluationApplyDamageCorrectionsProps;
}

type Props = OwnProps & Omit<AppModalProps, "children">;

export default function DamageCostEvaluationApplyDamageCorrectionsModal({
  subProps,
  ...dialogProps
}: Props) {
  return (
    <AppModal fullWidth maxWidth='lg' {...dialogProps}>
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>Apply damage corrections</AppModalTitle>
          <AppModalContent>
            <DamageCostEvaluationApplyDamageCorrections {...subProps} />
          </AppModalContent>
        </>
      )}
    </AppModal>
  );
}
